import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { JOB_STATUS_OPTIONS } from "../_status_labels";
import { sortByLabel } from "./_helpers";

export const select_job_statuses: Query<Ctx> = async (_ctx, _params) =>
  sortByLabel(JOB_STATUS_OPTIONS);
